/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UpdateKdsDevice200Response,
  UpdateKdsDeviceRequest,
} from '../models/index';
import {
    UpdateKdsDevice200ResponseFromJSON,
    UpdateKdsDevice200ResponseToJSON,
    UpdateKdsDeviceRequestFromJSON,
    UpdateKdsDeviceRequestToJSON,
} from '../models/index';

export interface UpdateKdsDeviceOperationRequest {
    deviceId: string;
    updateKdsDeviceRequest?: UpdateKdsDeviceRequest;
}

/**
 * 
 */
export class DevicesApi extends runtime.BaseAPI {

    /**
     */
    async updateKdsDeviceRaw(requestParameters: UpdateKdsDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateKdsDevice200Response>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling updateKdsDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/devices/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateKdsDeviceRequestToJSON(requestParameters['updateKdsDeviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateKdsDevice200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateKdsDevice(requestParameters: UpdateKdsDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateKdsDevice200Response> {
        const response = await this.updateKdsDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
